<template>
  <div class="login">
    <!-- <topTitle title=""></topTitle> -->
    <div class="topTitle isFixed">
      <div class="img" @click="fanhui">
        <img src="../../assets/localImage/return.png" alt />
      </div>
    </div>
    <div class="logo">
      <img src="../../assets/img/logo.png" alt />
    </div>
    <div class="input">
      <input type="text"  v-model="phone" placeholder="请输入手机号" @blur="onBlur" @focus="onFocus"/>
    </div>

    <div class="input">
      <input type="text" v-model="code" placeholder="请输入验证码"  @blur="onBlur" @focus="onFocus"/>
      <button class="code" @click="getCodeFun" :disabled="disabled">
        <template v-if="sending">
          <p class="color-orange">获取验证码</p>
        </template>
        <template v-else>{{second}}s</template>
      </button>
    </div>

    <div class="input" v-if="register">
      <input type="text" v-model="invitation_code" placeholder="请输入邀请码" @blur="onBlur" @focus="onFocus"/>
    </div>
    <p class="color-orange textL" v-show="isPone">请输入正确的手机号</p>

    <div class="boxBtn">
      <button class="loginBtn" :disabled="btnShow" @click="login()">{{register?'注册':'登录'}}</button>
    </div>

    <div class="user">
      <p v-if="register" @click="loginFun()">返回登录</p>
     
      <p v-else>
        <span @click="loginOld()" style="color:#1e89e0">老用户登录</span>
        <span  @click="registerFun()">新用户注册</span>
      </p>
    </div>
    <template v-if="!register">
      <div class="fast">
        <div class="line"></div>
        <div>快捷登录</div>
        <div class="line"></div>
      </div>
      <div class="weixin" @click="wxlogin()">
        <div>
          <img src="../../assets/img/weixin.png" alt />
        </div>
        <p>微信登录</p>
      </div>
    </template>

    <van-dialog v-model="show" confirmButtonColor="#F2190B" class="cgdialog" @confirm='queren()'>
      <div class="chenggong">
        <img src="../../assets/img/chenggong.png" alt />
        <P>注册成功</P>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
// import topTitle from "../../components/topTitle.vue";
export default {
  name: "login",
  data() {
    return {
      btnShow: false,//防止重复点击
      phone: "",//手机号
      isPone: false,//验证是否是正确手机号
      register: this.$route.query.type == 1 ? true : false,//是注册还是登陆
      code: "",//验证码
      invitation_code:'',//邀请码
      sending: true, //是否发送验证码
      disabled: false, //是否禁发验证码
      second: 60, //倒计时间
      show: false,//控制注册成功的弹出框
      result:'',//倒计时的定时器
    };
  },
  components: {},
  created(){
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
    });
    
    //如果有邀请码就说明是邀请过来的
    if(this.$route.query.invitation_code&& !this.$route.query.unionId){
      this.register = true;
      this.invitation_code = this.$route.query.invitation_code;
      // if(this.$route.query.invitation_code&&this.$route.query.unionId){
      //   localStorage.setItem('isLogin',true);
      // }
      localStorage.clear();
    }
    // else if(this.$route.query.invitation_code&&eval(localStorage.getItem('isLogin'))){}
    if(this.$route.query.unionId && !eval(localStorage.getItem('isLogin'))){
      this.weixinlogin()
      // this.$router.push({ path: "/bind" });
    }else{
      if(eval(localStorage.getItem('isLogin'))){
        let urls = localStorage.getItem('redirect_url');
        urls=urls.replace('?from=singlemessage', '');
        if(urls == '' || urls==null){
          this.$router.push({path:'/',});
        }else{
          window.location.href = urls
        }
      }else{
        let uuid  = this.s20();
        localStorage.setItem('uuid',uuid)
      }
      
    }
  },
  mounted(){
    let url = window.location.href.replace('?from=singlemessage', '');
    this.redirect_url = encodeURIComponent(url);
  },
  methods: {
    weixinlogin(){
      let uuid  = this.s20();
      localStorage.setItem('uuid',uuid)
      let param = {
        unionid:this.$route.query.unionId,
        uuid:uuid
      };
      this.getRequest(`passport/login/wechartLogin`, param).then(res => {
        if(res.data.code == 0){//绑定过  登录成功
          let url = localStorage.getItem('redirect_url').replace('?from=singlemessage', '');
          localStorage.setItem("uid", res.data.data.uid);
          localStorage.setItem("token", res.data.data.access_token);
          localStorage.setItem("isLogin", true);
          if(url){
            window.location.href = url;
          }else{
            this.$router.push({ name: "index" });
          }
        }else{//没绑定过
          this.$router.push({ path: "/bind" ,query: { 
            username: this.$route.query.username,
            nickname: this.$route.query.nickname,
            face: this.$route.query.face,
            unionid: this.$route.query.unionId
          }});
        }
      });
    },
    //失焦与聚焦事件处理ios弹出键盘页面错位问题
    onBlur() {
      setTimeout(function() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      }, 300);
    },
    onFocus(e) {
      setTimeout(function() {
        e.target.scrollIntoView({block: "center"});
        // document.body.scrollTop = this.showHeight;
      }, 300);
    },
    //返回首页
    fanhui() {
      this.$router.replace({ path: "/" });
    },
    //点击注册成功确认后
    queren(){

      // let url = localStorage.getItem('redirect_url');
      // if(url){
      //   window.location.href = url;
      // }else{
      //   this.$router.push({ path: "/" });
      // }
      this.getAuth();
    },


    wxlogin() {
      let url = window.location.href.replace('?from=singlemessage', '')+'?';
      this.redirect_url = encodeURIComponent(url);
      this.getAuth()
      // let appid = "wx68704eb273b3294e";
      // let redirect_uri = window.location.href; // 授权登录成功回调的地址，一般为当前页
      // let redirect_uri = 'http://buyer-api.test.786shop.qiawei.com'; // 授权登录成功回调的地址，一般为当前页
      // let pages = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}/&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
      // window.location.href = pages;
    },
   
    getAuth() {
      
      let getuid = localStorage.getItem("uid"); 
      // let pages =`https://buyer-api.jiuleimall.com/api/v1/passport/connect/wechat/auth?uuid=${getuid}&redirect_url=${this.redirect_url}`;
      // let pages = `https://123.56.253.83:7002/api/v1/passport/connect/wechat/auth?uuid=${getuid}&redirect_url=${this.redirect_url}`;
      // let pages = `http://buyer-api.test.786shop.qiawei.com/api/v1/passport/connect/wechat/auth?uuid=${getuid}&redirect_url=${this.redirect_url}`;

      let pages =`https://buyer-api.jiuleimall.com/api/v1/passport/connect/wechat/auth?uuid=${getuid}&redirect_url=${this.redirect_url}`;

    //  console.log(this.redirect_url)
      window.location.href = pages;
      
    },
    login() {
      //验证手机号
      if (!this.isPoneFun(this.phone)) {
        this.isPone = true;
        Toast("请输入正确的手机号");
        return false;
      }
      //验证是否输入code
      if (this.code == "") {
        Toast("请输入验证码");
        return false;
      }
      //禁止按钮点击
      this.btnShow = true;
      setTimeout(()=>{
        this.btnShow = false;
      },1000)
      if (this.register) {//注册
        let param = {
          password: "e10adc3949ba59abbe56e057f20f883e",
          mobile: this.phone,
          invitation_code: this.invitation_code,
          sms_code: this.code,
          face: this.$route.query.face,
          nickName: this.$route.query.nickName,
          uuid: localStorage.getItem('uuid'),
        };
        this.postRequest(`passport/register`, param).then(res => {
          if(res.data.code==1){
            Toast(res.data.message);
          }else{
            localStorage.setItem("token", res.data.data.access_token);
            localStorage.setItem("uid", res.data.data.uid);
            localStorage.setItem("isLogin", true);
            this.show = true

          }
          clearInterval(this.result);
          this.code = '';
          this.sending = true;
          this.second = 60;
          this.disabled = false;
          this.btnShow = false;
        });
      } else {//登陆
      
        let param = {
          sms_code: this.code,
          uuid: localStorage.getItem('uuid'),
        };
        this.getRequest(`passport/login/${this.phone}`, param).then(res => {
          localStorage.setItem("loginInfo", JSON.stringify(res.data.data));
          localStorage.setItem("token", res.data.data.access_token);
          localStorage.setItem("uid", res.data.data.uid);
          localStorage.setItem("isLogin", true);
          
          // let urls  = String(url).replace(/http/, "https");
          // console.log(urls);
          let urls = localStorage.getItem('redirect_url');
          if(urls == '' || urls==null){
            let url = window.location.href;
            this.redirect_url = encodeURIComponent(url);
          }else{
            this.redirect_url = encodeURIComponent(urls);
          }
          this.getAuth();
          this.btnShow = false;
        }).catch(err=>{

        });
      }
    },
    //显示注册
    registerFun() {
      this.register = true;
    },
    //显示登陆
    loginFun() {
      this.register = false;
    },
    loginOld() { //老用户登录
        this.$router.push({
            name:"loginOld"
        })
    },
    //获取验证码
    getCodeFun() {
      if (!this.sending) return;
      if (this.isPoneFun(this.phone)) {
        if (this.register) {
          this.postRequest(`passport/register/smscode/${this.phone}`).then(
            res => {
              this.sending = false;
              this.disabled = true;
              this.timeDown();
            }
          );
        } else {
          let param = {};
          param.uuid = localStorage.getItem('uuid');

          // param.uuid = this.s20();
          // localStorage.setItem("uuid", param.uuid);
          param.captcha = "786s";
          this.postRequest(`passport/login/smscode/${this.phone}`, param).then(
            res => {
              if (res.data.code == 1) {
                Toast.fail(res.data.message);
              } else {
                this.sending = false;
                this.disabled = true;
                this.timeDown();
              }
            }
          );
        }
      } else {
        this.isPone = true;
        Toast("请输入正确的手机号");
      }
    },
    //倒计时
    timeDown() {
      this.result = setInterval(() => {
        --this.second;
        if (this.second < 0) {
          clearInterval(this.result);
          this.sending = true;
          this.disabled = false;
          this.second = 60;
        }
      }, 1000);
    },
  }
};
</script>


<style scoped lang='less'>
.cgdialog {
  border-radius: 6px;
  width: 540px;
}
.chenggong {
  height: 270px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    width: 78px;
    height: 78px;
    margin-bottom: 30px;
  }
}
.login {
  .topTitle {
    padding: 0 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    height: 89px;

    .img {
      width: 20px;
      height: 36px;
    }
    h2 {
      font-weight: 500;
      font-size: 36px;
      // color: ;
    }
    button {
      font-size: 26px;
      font-weight: 400;
      background-color: #ffffff;
      color: #000000;
    }
  }

  background: #fff;
  height: 100%;
  position: fixed;
  width: 100%;
  .logo {
    width: 205px;
    // height: 177px;
    margin: 50px auto 100px auto;
  }
  .textL {
    width: 662px;
    padding: 0 20px;
    margin: 0 auto;
  }
  .input {
    width: 662px;
    height: 88px;
    line-height: 88px;
    margin: 40px auto;
    position: relative;
    > p.color-orange {
      padding: 15px 25px;
    }
    input {
      width: 662px;
      height: 88px;
      line-height: 88px;
      background-color: #f5f5f5;
      font-size: 28px;
      border-radius: 44px;
      padding-left: 45px;
    }
    .code {
      width: 203px;
      height: 70px;
      line-height: 70px;
      text-align: center;
      color: #8f8f8f;
      border-radius: 44px;
      position: absolute;
      right: 9px;
      bottom: 9px;
      background: #fff;
    }
  }
  .boxBtn {
    width: 100%;
    text-align: center;
  }
  .loginBtn {
    width: 662px;
    height: 88px;
    line-height: 88px;
    background: linear-gradient(
      90deg,
      rgba(242, 20, 12, 1) 0%,
      rgba(254, 119, 0, 1) 99%
    );
    border-radius: 44px;
    text-align: center;
    color: #fff;
    margin: 50px auto 50px auto;
    font-size: 32px;
  }
  .user {
    width: 662px;
    margin: auto;
    color: #5f5f5f;
    text-align: right;
    padding-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    p{
      // width: 140px;
      span{
        margin-left: 25px;;
      }
    }
  }

  .fast {
    width: 662px;
    margin: auto;
    display: flex;
    color: #efefef;
    justify-content: space-between;
    align-items: center;
    margin-top: 80px;
    margin-bottom: 50px;
    .line {
      width: 240px;
      height: 2px;
      font-size: 24px;
      background-color: #efefef;
    }
  }
  .weixin {
    text-align: center;
    > div {
      width: 88px;
      height: 88px;
      img {
        width: 100%;
        height: 100%;
      }
      margin: 20px auto;
    }
    p {
      color: #999999;
    }
  }
}
</style>


